import { useState } from "react";
import { faqItems } from "@/mocks/categories";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            Everything you need to know about <strong>GTBuy spreadsheet</strong>, <strong>Kakobuy spreadsheet</strong>, and <strong>Superbuy spreadsheet</strong> systems.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/60 transition-colors"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-add-line w-5 h-5 flex items-center justify-center text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`px-5 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}